import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from '../../environments/environment';

@Component({
    selector: 'main',
    templateUrl: 'main.component.html',
    styleUrls: ['main.component.css'],
    animations: [
        trigger('enterTrigger', [
            state('fadeIn', style({
                opacity: '1',
                // transform: 'translateY(50%)'
            })),
            transition('void => *', [style({opacity: '0'}), animate('300ms')]),
        ]),
    ],
})
export class MainComponent implements OnInit {

    @Output() notify: EventEmitter<string> = new EventEmitter<string>();

    view: string;

    constructor() {
        if (environment.production) {
            this.view = 'Start';
        } else {
            this.view = 'Start';
            // this.view = 'Result';
        }
        // this.view = "Result";
        // this.view = "Test";
    }

    onStart() {
        this.view = 'Test';
        // this.view = "Result";
    }

    onEnd() {
        this.view = 'Result';
        this.notify.emit('Result');
    }

    restart(event: string) {
        // console.log("event: " + event)
        this.view = 'Test';
        this.notify.emit('Test');
    }

    ngOnInit() {
    }


}
